import React, { useState } from "react";
import { reportsApi } from "../../api/auctiongate.js";
import { useAuth } from "../../auth/useAuth.js";

export default function Carfax() {
  const { user } = useAuth();
  const reports = user?.reports || {};
  const [vin, setVin] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);

  const check = async () => {
    if (!vin) return;
    setBusy(true);
    setErr(null);
    setRes(null);
    try {
      const r = await reportsApi.check(vin);
      setRes(r);
    } catch (e) {
      setErr(e?.message || "Check failed");
    } finally {
      setBusy(false);
    }
  };

  const buy = async () => {
    if (!vin) return;
    setBusy(true);
    setErr(null);
    try {
      const r = await reportsApi.buy({ vin });
      setRes(r);
    } catch (e) {
      setErr(e?.message || "Buy failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card">
      <div className="card__title">
        Carfax Reports
        <span className="badge">{reports.reportAvailable === "yes" ? "available" : "off"}</span>
      </div>
      <dl className="kv small">
        <dt>Can buy</dt>
        <dd>{reports.canBuyReport ?? "—"}</dd>
        <dt>Daily limit</dt>
        <dd>{reports.limitPurchasedReportsPerDay ?? "—"}</dd>
        <dt>Purchased today</dt>
        <dd>{reports.countPurchasedReport ?? "—"}</dd>
      </dl>

      <div className="row mt-2">
        <input
          value={vin}
          onChange={(e) => setVin(e.target.value)}
          placeholder="Enter VIN"
          style={input}
        />
        <button className="btn btn-ghost" onClick={check} disabled={busy || !vin}>
          Check
        </button>
        <button className="btn btn-primary" onClick={buy} disabled={busy || !vin}>
          Buy report
        </button>
      </div>

      {err && <div className="login-error mt-2">{err}</div>}
      {res && (
        <pre style={{ fontSize: 12, marginTop: 10, maxHeight: 180, overflow: "auto", background: "var(--color-bg-card-elevated)", padding: 10, borderRadius: 6 }}>
          {JSON.stringify(res, null, 2)}
        </pre>
      )}
    </div>
  );
}
const input = {
  padding: "8px 10px",
  border: "1px solid var(--color-border-input)",
  borderRadius: 8,
  fontSize: 13,
  flex: 1,
  minWidth: 140,
};
